export default __webpack_public_path__ + "static/media/Hibernate.49032b65.png";